module.exports = __webpack_public_path__ + "img/coverimg.3b1ac709.jpg";